import { makeStyles } from "@material-ui/core";
import { colorsLight } from "../../themes";

export const useDenialsStyles = makeStyles((theme) => ({
  denialReasonContainer: {
    display: "flex",
    alignItems: "center",
  },
  denialText: {
    color: colorsLight.info.main,
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "120%",
  },
  infoIcon: {
    color: colorsLight.info.main,
    position: "relative",
    top: "4px",
  },
  denialReason: {
    paddingBottom: "16px",
    paddingTop: "8px",
  },
}));
